import {CSSProperties} from 'react';

interface IProps {
  bgColorRgb?: string;
  className?: string;
  style?: CSSProperties;
}

export default function ContentCardGradientMaskV4({
  bgColorRgb = 'var(--any-black)',
  className,
  style,
}: IProps) {
  return (
    <div
      className={cn('w-full h-1/2 absolute bottom-0 left-0', className)}
      style={{
        backgroundImage: `linear-gradient(
          180deg,
          rgba(${bgColorRgb}, 0) 0%,
          rgba(${bgColorRgb}, 0.5) 33.04%,
          rgba(${bgColorRgb}, 0.9) 66.09%,
          rgba(${bgColorRgb}, 1) 100%
        )`,
        ...style,
      }}
    />
  );
}
